export interface LoadshopShipperMapping {
  loadshopShipperMappingId: number;
  ownerId: string;
  customerId: string;
  sourceSystem: string;
  loadshopShipperId: string;
  isActive: boolean;
  useCustomerOrderNumber: boolean;
  usesAllInRates: boolean;
  usesSmartSpotPricing: boolean;
  useTopsLoadContacts: boolean;
  useCustomerFuel: boolean;
  autoApplyCarrierGroup: boolean;
  arSpotQuoteEligible: boolean;
  createDtTm: Date;
  createBy: string;
  lastChgDtTm: Date;
  lastChgBy: string;
}

export const defaultLoadshopShipperMapping: LoadshopShipperMapping = {
  loadshopShipperMappingId: 0,
  ownerId: null,
  customerId: null,
  sourceSystem: null,
  loadshopShipperId: null,
  isActive: true,
  useCustomerOrderNumber: false,
  usesAllInRates: false,
  usesSmartSpotPricing: false,
  useTopsLoadContacts: false,
  useCustomerFuel: false,
  autoApplyCarrierGroup: false,
  arSpotQuoteEligible: false,
  createDtTm: new Date(),
  createBy: null,
  lastChgDtTm: new Date(),
  lastChgBy: null,
};
